window.doclrModal = (function () {
    'use strict';

    let uibModal;
    let rootScope;

    return {
        simpleModal: simpleModal,
        confirmModal: confirmModal,
        datepickerModal: datepickerModal,
        inputModal: inputModal,
        newModal: newModal
    };

    function loadModal() {
        if (!uibModal) {
            uibModal = angular.element(document.body).injector().get('$uibModal');
        }
        if (!rootScope) {
            rootScope = angular.element(document.body).injector().get('$rootScope');
        }
    }

    function simpleModal(title, message, closeButtonText) {
        loadModal();
        const scope = rootScope.$new(true);
        scope.simplemodal = {
            title: title,
            message: message,
            closeButtonText: closeButtonText
        };

        const modalInstance = uibModal.open({
            templateUrl: '/partials/components/simplemodal.html',
            scope: scope
        });

        return modalInstance.result.then(()=>{},()=>{});
    }

    function confirmModal(title, question) {
        loadModal();
        const scope = rootScope.$new(true);
        scope.confirmmodal = {
            title: title,
            question: question
        };

        const modalInstance = uibModal.open({
            templateUrl: '/partials/components/confirmmodal.html',
            scope: scope
        });

        return modalInstance.result;
    }


    function datepickerModal (title, question, dateLabel, date, minDateOffset){

        loadModal();
        const scope = rootScope.$new(true);
        scope.datepickerModal = {
            title: title,
            question: question,
            dateLabel: dateLabel,
            date: date,
            minDate : typeof minDateOffset === 'undefined' ? '' : minDateOffset
        };

        const modalInstance = uibModal.open({
            templateUrl: '/partials/components/datepickermodal.html',
            scope: scope
        });

       return modalInstance.result.then(function(){
            return scope.datepickerModal.date;
        });
    }

    function inputModal (title, question, inputLabel){

        loadModal();
        const scope = rootScope.$new(true);
        scope.inputModal = {
            title: title,
            question: question,
            inputLabel: inputLabel
        };

        const modalInstance = uibModal.open({
            templateUrl: '/partials/components/inputmodal.html',
            scope: scope
        });

        return modalInstance.result.then(function(){
            return scope.inputModal.textValue;
        });
    }

    function newModal(modalVM, templateUrl){

        loadModal();

        const scope = rootScope.$new(true);
        scope.modalVM = modalVM;

        const modalInstance = uibModal.open({
            templateUrl: templateUrl,
            scope: scope
        });

        modalInstance.result.then(angular.noop, angular.noop);

        return modalInstance;
    }
})();
